import React from 'react';
import { MessageSquare } from 'lucide-react';
import ChatRequestsPanel from '@/components/ChatRequestsPanel';

export default function ChatEmpty() {
    return (
        <div className="h-full flex flex-col items-center justify-center p-6">
            <div className="max-w-md w-full">
                {/* Chat Requests Panel */}
                <ChatRequestsPanel />

                {/* Empty state message */}
                <div className="mt-6 text-center p-8 bg-white rounded-lg shadow">
                    <div className="mb-4 flex justify-center">
                        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
                            <MessageSquare className="w-8 h-8 text-primary" />
                        </div>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">No chat selected</h3>
                    <p className="text-gray-600">
                        Select a conversation from the list or wait for new chat requests.
                    </p>
                </div>
            </div>
        </div>
    );
}